module.exports = __webpack_public_path__ + "img/number-circle-4.bd62a9aa.png";